import { BaseEntity } from "../../core";

export class MigratedSinester extends BaseEntity {
    sinesterId: number;
    number: number;
    sinesterDate: Date;
    sinesterDateString: string;
    insuredName: string;
    insurerCode: number;
    policyNumber?: number;
    driverName: string;
    licensePlate: string;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/MigratedSinester.ts